import { render, staticRenderFns } from "./test_component.vue?vue&type=template&id=7eaf9f72&scoped=true"
import script from "./test_component.vue?vue&type=script&lang=js"
export * from "./test_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaf9f72",
  null
  
)

export default component.exports